module.exports = __webpack_public_path__ + "img/salariunioniWhite.fae581c3.svg";